// extracted by css-extract-rspack-plugin
export default {"aside":"Aside-module__aside___DOr2Z","asideItem":"Aside-module__asideItem___N4n_U","asideText":"Aside-module__asideText___QxDYr"};